import React, { useEffect, useState, useCallback } from "react";
import { ClassName } from "@beable/roster-backend-client-v1";
import provisionService from "../../../../services/ProvisionService";
import { Grid, Typography } from "@mui/material";
import { upperFirst } from "lodash";

interface UserProvisionedClassesDataProps {
  siteId: number;
  academicYearId: string;
  userId: string;
  classNames?: ClassName[];
  setProvisionedClasses: (classes: ClassName[]) => void;
}

export default function UserProvisionedClassesData({
  siteId,
  academicYearId,
  userId,
  classNames,
  ...props
}: UserProvisionedClassesDataProps) {
  const [provisionedClasses, setProvisionedClasses] = useState<
    ClassName[] | undefined
  >([]);

  const propsSetClasses = useCallback(props.setProvisionedClasses, []);

  useEffect(() => {
    const fetchProvisionedData = async () => {
      if (!classNames?.length) {
        return;
      }

      const provisionedClassesResp =
        await provisionService.getProvisionedClasses(
          siteId,
          academicYearId,
          userId
        );
      const classes = provisionedClassesResp.length
        ? classNames?.filter((c: ClassName) =>
            provisionedClassesResp.includes(c.classId)
          )
        : [];
      setProvisionedClasses(classes);
      if (classes.length) {
        propsSetClasses(classes);
      }
    };

    fetchProvisionedData();
  }, [userId, siteId, academicYearId, classNames, propsSetClasses]);

  return (
    <Grid size={12}>
      {provisionedClasses?.length ? (
        provisionedClasses.map((userClass) => (
          <Typography key={userClass.classId}>
            {upperFirst(userClass.className)}
          </Typography>
        ))
      ) : (
        <Typography>No provisioned classes found</Typography>
      )}
    </Grid>
  );
}
